import MemberContractHistory from './MemberContractHistory';
import MemberContractState from './MemberContractState';
import ParameterValue from './ParameterValue';

export default class Member {

    static GENDER_MALE = 'gender.m';
    static GENDER_FEMALE = 'gender.f';
    static GENDER_DIVERSE = 'gender.v';
    static GENDER_UNDEFINED = 'gender.u';

    fullName() {
        let fullName = this.lastName;

        if (this.firstName) {
            fullName = this.firstName + ' ' + fullName;
        }

        if (this.academicTitle) {
            fullName = this.academicTitle.value + ' ' + fullName;
        }

        return fullName;
    }

    fullNameAndAddress() {
        let result = this.fullName();
        if (this.street) {
            result += ', ' + this.street;
        }
        if (this.zip && this.city) {
            result += ', ' + this.zip + ' ' + this.city;
        }
        return result;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        let member = new Member();
        member.id = data.id;
        member.firstName = data.firstName || data.first_name;
        member.lastName = data.lastName || data.last_name;
        member.gender = data.gender;
        member.dateOfBirth = data.dateOfBirth;
        member.age = data.age === false ? '' : data.age;
        member.street = data.street;
        member.careOf = data.careOf;
        member.zip = data.zip;
        member.city = data.city;
        member.country = data.country;
        member.phone = data.phone;
        member.phoneMobile = data.phoneMobile;
        member.email = data.email;
        member.hasAvatar = data.hasAvatar;
        member.avatarFileName = data.avatarFileName;
        member.membershipNumber = data.membershipNumber;
        member.placeOfBirth = data.placeOfBirth;
        member.birthName = data.birthName;
        member.nationality = data.nationality;
        member.contractState = data.contractState ? new MemberContractState(
            data.contractState.status,
            data.contractState.contractType,
        ) : null;
        member.contractHistory = MemberContractHistory.fromData(data.contracts) || null;
        member.comment = data.comment;
        member.bookkeepingComment = data.bookkeepingComment;
        member.isEditableBasicData = data.isEditableBasicData;
        member.isBookkeepingCommentViewable = data.isBookkeepingCommentViewable;
        member.isShortProfileViewable = data.isShortProfileViewable;

        member.academicTitle = null;
        if (data.academicTitle && data.academicTitle.data) {
            member.academicTitle = ParameterValue.fromData(data.academicTitle.data);
        }

        member.company = data.company;
        member.phoneBusiness = data.phoneBusiness;
        member.phoneMobileBusiness = data.phoneMobileBusiness;
        member.emergencyContact = data.emergencyContact;
        member.emailBusiness = data.emailBusiness;

        member.contractEnd = data.contractEnd || null;
        member.departments = data.departments || null

        Object.seal(member);
        return member;
    }

}
